<template>
    <template v-if="customerConfig.sale_office_code === 'PS'">
        <p>PN-PT 8:00 - 16:00</p>
        <p>
            <a href="tel:+48781731777" class="hover:text-zinc-400">+48 781 731 777</a>
        </p>
        <p>
            <a href="tel:+48609225038" class="hover:text-zinc-400">+48 609 225 038</a>
        </p>
        <p>
            <a href="mailto:projekty.specjalne@etos.pl" class="hover:text-zinc-400"
            >projekty.specjalne@etos.pl</a
            >
        </p>
    </template>
    <template v-else-if="customerConfig.sale_office_code === 'CLTN'">
        <p>PN-PT 8:00 - 16:00</p>
        <p>Bartosz Moćko</p>
        <p>
            <a href="tel:+48781731777" class="hover:text-zinc-400">+48 782 003 809</a>
        </p>
        <p>
            <a href="mailto:b.mocko@etos.pl" class="hover:text-zinc-400"
            >b.mocko@etos.pl</a
            >
        </p>
    </template>
    <template v-else>
        <p>
            <a href="mailto:b2b@etos.pl" class="hover:text-zinc-400">b2b@etos.pl</a>
        </p>
    </template>
</template>

<script>
export default {
    name: "Contact",
    props: {
        customerConfig: {
            type: Object,
            required: true,
        },
    },
};
</script>